import { all, put, call, takeEvery } from 'redux-saga/effects'

import { getNews } from '../api'
import { apiError, showPopup, i18n } from '../helpers'
import { captureException } from '../helpers/Sentry'
import { logout, LOGOUT } from './auth'

const initialState = {
  entities: [],
  loading: false,
  error: null
}

export const moduleName = 'news'
export const FETCH_NEWS_REQUEST = `${moduleName}/FETCH_NEWS_REQUEST`
export const FETCH_NEWS_SUCCESS = `${moduleName}/FETCH_NEWS_SUCCESS`
export const FETCH_NEWS_FAIL = `${moduleName}/FETCH_NEWS_FAIL`

export default function reducer(state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case FETCH_NEWS_REQUEST:
      return { ...state, loading: true, error: null }
    case FETCH_NEWS_SUCCESS:
      return { ...state, loading: false, error: null, entities: payload }
    case FETCH_NEWS_FAIL:
      return { ...state, loading: false, error: payload }
    case LOGOUT:
      return { ...initialState }

    default:
      return state
  }
}

export function fetchNews() {
  return {
    type: FETCH_NEWS_REQUEST
  }
}

export const fetchNewsSaga = function*() {
  try {
    const { language } = i18n
    const payload = yield call(getNews, language)

    yield put({
      type: FETCH_NEWS_SUCCESS,
      payload
    })
  } catch (e) {
    yield put(showPopup(e))
    if (e instanceof apiError) {
      const { code, message } = e
      yield put({
        type: FETCH_NEWS_FAIL,
        payload: {
          code,
          message
        }
      })
      if (code === 2) {
        yield put(logout())
      }
    } else {
      yield put({
        type: FETCH_NEWS_FAIL,
        payload: {
          code: 0,
          message: 'look what I got!'
        }
      })
      // TODO call some cross-screen error
      captureException(e)
    }
  }
}

export const saga = function*() {
  yield all([takeEvery(FETCH_NEWS_REQUEST, fetchNewsSaga)])
}
